import React, { useState, useEffect, useRef, useContext } from "react";

// Librerias de componentes
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";

import Card from "../../../../Base/Components/Card/Card";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";

import { ObtenerTipoProductos } from "../../../../Base/API/Global/TipoProducto/TipoProductoRequest";

import TipoProductoCrudModal from "./TipoProductoCrud/TipoProductoCrud";


export const TipoProductoScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [tipoProducto, setTipoProducto] = useState("");
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(true);

  const getInfo = async () => {
    setLoading(true);
    const tp = await ObtenerTipoProductos();
    setTipoProducto(tp?.filter(i => i?.IdStatus !== 7));
    setLoading(false);
  };

  useEffect(() => {
    window.document.title = "CSM • TipoProducto";
    getInfo();
  }, []);

  const colums = [
    {
      field: "IdTipoProducto",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "NombreTipoProducto",
      header: "Tipos de Productos",
      headerEn: "Product Types",
      Flex: 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "NombreSubcategoria",
      header: "SubCategorías",
      headerEn: "SubCategories",
      flex: 1,
    },
    {
      field: "NombreCategoria",
      header: "Categorías",
      headerEn: "Categories",
      flex: 1,
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "IdTipoProducto",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          className: "custom-tooltip",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: tipoProducto,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "subcategoria", config.language));
  }, [])

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast}></Toast>
      <Card
        titulo={
          <div className="botones">

            <h3>{getLabel(baseLang, "tipo", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button icon='pi pi-plus' severity='success' onClick={() => {
              setShowDialog(true);
              setSelected(null);
            }} />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
      {showDialog && <TipoProductoCrudModal toastRef={toast} tipoProductoDialog={showDialog} TipoProducto={selected} setTipoProductoDialog={setShowDialog} getTipoProducto={getInfo} modo={selected ? "Editar" : "Crear"}/>}

    </div>
  );
};

export default TipoProductoScreen;
